import { IconButton, Tooltip, useTheme } from '@mui/material'
import React from 'react'
import { InfoIconOutlined } from '../../../assets/SvgIcons'

type Props = {
    title?: string
    desc?: string
}

function InfoToltip(props: Props) {
    const { title, desc } = props
    const { palette, typography } = useTheme()

    return (
        <Tooltip
            slotProps={{
                tooltip: {
                    sx: {
                        margin: "0px !important",
                        backgroundColor: "transparent"
                    }
                }
            }}
            title={
                <div
                    style={{
                        borderRadius: '10px', backgroundColor: '#0F131F', padding: '15px'
                    }}
                >
                    {title &&
                        <>
                            <span
                                style={{
                                    color: palette.primary[500],
                                    fontWeight: '600',
                                    fontSize: '16px'
                                }}
                            >
                                {title}

                            </span>
                            <br />
                        </>
                    }
                    {desc &&
                        <span style={{ ...typography.subtitle_500, fontFamily: typography.fontFamily }}>{desc}</span>
                    }
                </div>
            }
        >
            <IconButton>
                <InfoIconOutlined />
            </IconButton>
        </Tooltip>
    )
}

export default InfoToltip